//
export default [
  {
    text: 'N° Folio',
    value: 'dte_number',
  },
  {
    text: 'Rut',
    value: 'sl_customer_rut',
    format: 'rut',
    sortable: 'sl_customer_id',
  },
  {
    text: 'Cliente',
    value: 'sl_customer_business_name',
    sortable: 'sl_customer_id',
  },
  {
    text: 'Sucursal',
    value: 'sl_customer_branch_offices_address',
    sortable: 'sl_customer_branch_offices_id',
  },
  {
    text: 'Tipo',
    align: 'center',
    value: 'type',
    component: {
      type: 'chip-label',
      props: {
        palette: {
          'factura_electrónica': 'secondary lighten-3',
          'boleta_electrónica': 'info lighten-3',
          'nota_de_crédito': 'accent lighten-3',
          'nota_de_débito': 'error lighten-3',
        },
        small: true,
      },
    },
    sortable: true,
  },
  {
    text: 'Emisión',
    value: 'emission_date',
    align: 'right',
    format: 'date',
    sortable: true,
  },
  {
    text: 'Monto',
    value: 'total',
    format: 'currency',
    align: 'right',
    sortable: true,
  },
  {
    text: 'Fecha Contable',
    value: 'accounting_date',
    align: 'right',
    format: 'date',
    sortable: true,
  },
]
